module.exports = __webpack_public_path__ + "assets/0094657e004e51097a0640af4d681037.png";